import styled from "styled-components";

export const LogoImg = styled.img`
  && {
    display: inline-block;
    height: 36px;
  }
`;
